import { createFileRoute } from "@tanstack/react-router";
import { Mail, MessageSquare, ChefHat, ShieldCheck } from "lucide-react";

export const Route = createFileRoute("/contatti")({
  head: () => ({
    meta: [
      { title: "Contatti — ChefConnect Italia" },
      {
        name: "description",
        content:
          "Hai domande, segnalazioni o vuoi collaborare con ChefConnect Italia? Contatta il nostro team via email.",
      },
      { property: "og:title", content: "Contatti — ChefConnect Italia" },
      {
        property: "og:description",
        content: "Email di supporto, chef, privacy e collaborazioni.",
      },
      { property: "og:url", content: "https://chefconnectitalia.com/contatti" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://chefconnectitalia.com/contatti" }],
  }),
  component: ContattiPage,
});

const CONTACTS = [
  {
    icon: MessageSquare,
    label: "Supporto generale",
    desc: "Domande sulla piattaforma, problemi tecnici, segnalazioni.",
    email: "informazioni@chefconnectitalia.com",
  },
  {
    icon: ChefHat,
    label: "Supporto tecnico",
    desc: "Problemi con la piattaforma, bug, assistenza account.",
    email: "supporto@chefconnectitalia.com",
  },
  {
    icon: ShieldCheck,
    label: "Privacy e dati personali",
    desc: "Richieste relative ai tuoi dati (accesso, rettifica, cancellazione).",
    email: "privacy@chefconnectitalia.com",
  },
];

function ContattiPage() {
  return (
    <article className="container mx-auto max-w-3xl px-4 py-16 sm:py-24">
      <p className="text-xs font-medium uppercase tracking-[0.2em] text-gold">Contatti</p>
      <h1 className="mt-3 font-display text-5xl leading-tight sm:text-6xl">
        Parliamone.
      </h1>
      <p className="mt-6 text-lg text-muted-foreground">
        Il team di ChefConnect Italia risponde di norma entro 1–2 giorni
        lavorativi. Scegli il canale giusto per la tua richiesta.
      </p>

      <div className="mt-12 grid gap-4">
        {CONTACTS.map((c) => (
          <a
            key={c.email}
            href={`mailto:${c.email}`}
            className="group flex items-start gap-4 rounded-xl border border-border bg-card p-5 transition hover:border-gold hover:shadow-sm"
          >
            <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-secondary">
              <c.icon className="h-4 w-4 text-gold" />
            </span>
            <div className="min-w-0 flex-1">
              <h2 className="font-display text-lg leading-tight">{c.label}</h2>
              <p className="mt-1 text-sm text-muted-foreground">{c.desc}</p>
              <p className="mt-2 inline-flex items-center gap-1.5 text-sm font-medium text-foreground group-hover:text-gold">
                <Mail className="h-3.5 w-3.5" /> {c.email}
              </p>
            </div>
          </a>
        ))}
      </div>

      <section className="mt-14 rounded-xl border border-border bg-secondary/40 p-6">
        <h2 className="font-display text-xl">Sede</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          ChefConnect Italia · Italia. Per comunicazioni formali utilizza
          l'indirizzo email di riferimento sopra; ti forniremo i dati postali
          completi se necessari.
        </p>
      </section>

      <p className="mt-10 text-xs text-muted-foreground">
        Pagina mantenuta dal team di ChefConnect Italia.
      </p>
    </article>
  );
}